<template>
  <div>
    <ControlLabel
      v-bind="labelProps"
      :disabled="$attrs.disabled"
      :path="path"
      :responsive="responsive"
    >
      <slot name="before" />
      <slot>
        {{ label }}
      </slot>
      <slot name="after" slot="after" />
    </ControlLabel>

    <template v-if="hasIcon">
      <div :class="[$style.inputWithIconContainer, {'w-full': fullWidth}]">
        <span :class="$style.iconContainer">
          <slot name="icon" />
        </span>

        <Input
          :class="[$style.inputWithIcon]"
          :value="value"
          v-bind="$attrs"
          :fullWidth="fullWidth"
          v-on="$listeners"
          @input="handleChange(undefined, $event)"
        />
      </div>
    </template>

    <Input
      v-else
      :value="value"
      v-bind="$attrs"
      :fullWidth="fullWidth"
      v-on="$listeners"
      @input="handleChange(undefined, $event)"
    />

    <Typography
      v-if="errorText"
      variant="caption"
      class="block mt-2"
      style="color: red"
    >
      {{ errorText }}
    </Typography>
  </div>
</template>

<script>
import ControlLabel from './ControlLabel';
import control from './control';

export default {
  mixins: [control],

  components: {ControlLabel},

  props: {
    labelProps: Object,
    errorText: String,
    label: String,
    responsive: Boolean,
    fullWidth: {
      default: true,
      type: Boolean,
    },
  },
  computed: {
    hasIcon() {
      return Boolean(this.$slots.icon);
    },
  },
};
</script>

<style module>
.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  min-width: 40px;

  @apply p-2
    border
    border-dull
    rounded-tl
    rounded-bl;
}

.inputWithIconContainer {
  display: inline-flex;
  align-items: stretch;
}

.inputWithIcon {
  border-left: none !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
</style>
